// extracted by mini-css-extract-plugin
export default {"wrapper":"eD-z","button":"fD-z","alternate":"gD-z","disabled":"hD-z","paymentWarning":"iD-z","fadeIn":"jD-z"};